import { Component, Input, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReviewWrapperComponent } from '../../../ui/review-wrapper/review-wrapper.component';
import { CampaignSchedule, MessageSchedule } from '../../../../services/campaign/schedule.service';
import { MessagesService } from '../../../../services/campaign/messages.service';
import { formatCountdown } from '../../../../../utils/sms';
import {
  formatRun,
  formatRunLength,
  formatScheduleWhen,
  scheduleMoment,
} from '../../../../pages/organization/campaigns/campaign-list/campaign-facts';

@Component({
  selector: 'app-schedule-review',
  standalone: true,
  imports: [ReviewWrapperComponent],
  templateUrl: './schedule-review.component.html',
  styleUrl: '../campaign-review.css',
})
export class ScheduleReviewComponent {
  @Input() campaignSchedule!: CampaignSchedule;
  @Input() messageSchedule: MessageSchedule[] = [];
  private messagesService = inject(MessagesService);

  constructor(private router: Router, private route: ActivatedRoute) {}

  /** Done when every message has at least one send time. */
  get everyMessageScheduled(): boolean {
    return (
      this.messageSchedule.length > 0 &&
      this.messageSchedule.every((schedule) => (schedule.messageDates ?? []).length > 0)
    );
  }

  get run(): string {
    return formatRun(this.campaignSchedule?.campaignStart, this.campaignSchedule?.campaignEnd);
  }

  get runLength(): string | null {
    return formatRunLength(this.campaignSchedule?.campaignStart, this.campaignSchedule?.campaignEnd);
  }

  /** Each message's send times, soonest first, shown with their time zone when it differs. */
  get groups() {
    const now = new Date();
    return (this.messageSchedule ?? []).map((schedule) => {
      const current = this.messagesService.savedMessages.find((message) => message.id === schedule.message?.id);
      return {
        id: schedule.id,
        subject: current?.subject || schedule.message?.subject || 'Untitled message',
        times: (schedule.messageDates ?? [])
          .map((row) => {
            const at = scheduleMoment(row.date, row.time, row.timezone);
            return {
              at,
              label: formatScheduleWhen(row.date, row.time, row.timezone),
              countdown: formatCountdown(at, now),
              past: !!at && at.getTime() <= now.getTime(),
            };
          })
          .sort((a, b) => (a.at?.getTime() ?? 0) - (b.at?.getTime() ?? 0)),
      };
    });
  }

  navigateToUrl() {
    this.router.navigate([], {
      relativeTo: this.route, // Stay on the current route
      queryParams: { step: 'schedule' }, // Add the new query param
    });
  }
}
